import type { ISolicitationItem } from "@/types/Solicitation.types"
import type { NotificationType } from "@/types/Notifications.types"

export type NotificationCenterItemKind = "solicitation" | "app_notification"

export type NotificationCenterTypeFilter =
  | "all"
  | "solicitations"
  | "review"
  | "sync"
  | "local_network"
  | "other"

export type NotificationCenterStateFilter = "all" | "unread"

export interface INotificationCenterFilters {
  type: NotificationCenterTypeFilter
  state: NotificationCenterStateFilter
  establishmentId: number | null
}

/** Sollicitation Uska Destination, agrégée hors contexte établissement */
export interface INotificationCenterSolicitationItem {
  id: string
  kind: "solicitation"
  establishmentId: number
  establishmentName: string
  /** Toujours true : le lu/non-lu ne s'applique pas aux sollicitations */
  read: boolean
  archived: boolean
  solicitation: ISolicitationItem
}

/** Notification applicative (base Uska) */
export interface INotificationCenterAppNotificationItem {
  id: string
  kind: "app_notification"
  establishmentId: number
  establishmentName: string
  title: string
  content: string
  createdAt: string
  read: boolean
  archived: boolean
  notificationType?: NotificationType
  pathName?: string | null
  link?: string | null
  externalId?: string | null
}

export type INotificationCenterItem =
  | INotificationCenterSolicitationItem
  | INotificationCenterAppNotificationItem

export function isNotificationCenterSolicitation(
  item: INotificationCenterItem
): item is INotificationCenterSolicitationItem {
  return item.kind === "solicitation"
}

export function isNotificationCenterAppNotification(
  item: INotificationCenterItem
): item is INotificationCenterAppNotificationItem {
  return item.kind === "app_notification"
}

export function getNotificationCenterItemCreatedAt(item: INotificationCenterItem): string {
  if (isNotificationCenterSolicitation(item)) {
    return item.solicitation.created_at || item.solicitation.answeredAt || ""
  }
  return item.createdAt
}
